var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h2',{class:_vm.badgeIconStatus},[_c('span',{class:_vm.badgeClass},[_c('i',{staticClass:"fas fa-trophy fa-stack-2x"}),('icon' in _vm.badge && _vm.badge.icon !== '')?_c('i',{class:_vm.badgeIcon}):_vm._e()])])}
var staticRenderFns = []

export { render, staticRenderFns }